import * as S from './HomePage.styles'
import React from 'react'

export const HomePage = () => {
  return (
    <S.HomePageContainer />
  )
}